import { Filter } from '@/app/models/filters'
import { FiltersService } from '@/app/services/FiltersService'
import { filtersActions, layoutActions, LayoutActivityType } from '@Techedge/digitalportal-shared'
import { ItemList } from '../../models/filters'
import { setFiltersDomain } from './activity-creation'
import { setFiltersOptionsMap } from './distribution'

export const FiltersAction = {
    GET_FILTERS_ERROR: 'GET_FILTERS_ERROR',
    GET_FILTERS_SUCCESS: 'GET_FILTERS_SUCCESS',
    SET_DEPARTMENT_LIST: 'SET_DEPARTMENT_LIST',
    SET_RECIPIENT_LIST: 'SET_RECIPIENT_LIST',
    SET_VISIBILITY_LIST: 'SET_VISIBILITY_LIST',
    SET_IS_FULLSCREEN: 'SET_IS_FULLSCREEN',
    SET_MACROAREA_LIST: 'SET_MACROAREA_LIST',
    SET_STORE_ID_LIST: 'SET_STORE_ID_LIST',
    GET_DISTRIBUTION_LISTS_SUCCESS: 'GET_DISTRIBUTION_LISTS_SUCCESS',
    GET_DISTRIBUTION_LISTS_REQUEST: 'GET_DISTRIBUTION_LISTS_REQUEST',
    GET_DISTRIBUTION_LISTS_ERROR: 'GET_DISTRIBUTION_LIST_ERROR',
    GET_DISTRIBUTION_LIST_SUCCESS: 'GET_DISTRIBUTION_LIST_SUCCESS',
    GET_DISTRIBUTION_LIST_REQUEST: 'GET_DISTRIBUTION_LIST_REQUEST',
    GET_DISTRIBUTION_LIST_ERROR: 'GET_DISTRIBUTION_LISTS_ERROR',
    SAVE_DISTRIBUTION_LIST_SUCCESS: 'SAVE_DISTRIBUTION_LIST_SUCCESS',
    SAVE_DISTRIBUTION_LIST_REQUEST: 'SAVE_DISTRIBUTION_LIST_REQUEST',
    SAVE_DISTRIBUTION_LIST_ERROR: 'SAVE_DISTRIBUTION_LIST_ERROR',
    SET_TYPE_FILTERS_LIST: 'SET_TYPE_FILTERS_LIST',
    SET_STORES_OPTIONS__LIST: 'SET_STORES_OPTIONS__LIST',
    SET_STORES_LIST: 'SET_STORES_LIST',
    DELETE_FILTERS_REQUEST: 'DELETE_FILTERS_REQUEST',
    DELETE_FILTERS_FAILURE: 'DELETE_FILTERS_FAILURE',
    DELETE_FILTERS_SUCCESS: 'DELETE_FILTERS_SUCCESS',
    SET_AS_FAVORITE_REQUEST: 'SET_AS_FAVORITE_REQUEST',
    SET_AS_FAVORITE_FAILURE: 'SET_AS_FAVORITE_FAILURE',
    SET_AS_FAVORITE_SUCCESS: 'SET_AS_FAVORITE_SUCCESS',
    SET_STATUS_LIST_OPTIONS: 'SET_STATUS_LIST_OPTIONS',
    SET_PRIORITIES_LIST_OPTIONS: 'SET_PRIORITIES_LIST_OPTIONS',
    APPLY_FILTER_SUCCESS: 'APPLY_FILTER_SUCCESS',
    APPLY_FILTER_FAILURE: 'APPLY_FILTER_FAILURE',
    SHOW_TOAST_EMPTY_FILTER_FAILURE: 'SHOW_TOAST_EMPTY_FILTER_FAILURE',
    SHOW_TOAST_SAVE_FILTER_SUCCESS: 'SHOW_TOAST_SAVE_FILTER_SUCCESS',
    SHOW_TOAST_SAVE_FILTER_FAILURE: 'SHOW_TOAST_SAVE_FILTER_FAILURE',
    SET_PROJECT_TYPE_OPTIONS: 'SET_PROJECT_TYPE_OPTIONS',
    SET_ACTIVITY_TYPES: 'SET_ACTIVITY_TYPES',
    GET_REPORT_TIMES_REQUEST: 'GET_REPORT_TIMES_REQUEST',
    GET_REPORT_TIMES_FAILURE: 'GET_REPORT_TIMES_FAILURE',
    GET_REPORT_TIMES_SUCCCESS: 'GET_REPORT_TIMES_SUCCCESS',
    SET_SELECTED_TIME_CLUSTER: 'SET_SELECTED_TIME_CLUSTER',
    STORE_LIST_DOWNLOAD_SUCCESS: 'STORE_LIST_DOWNLOAD_SUCCESS',
    STORE_LIST_DOWNLOAD_FAILURE: 'STORE_LIST_DOWNLOAD_FAILURE',
    SET_PHOTO_STATUS_LIST: 'SET_PHOTO_STATUS_LIST',
    SET_PHOTO_TAG_LIST: 'SET_PHOTO_TAG_LIST',
}

export const setSelectedTimeCluster = (value: string) => {
    return { type: FiltersAction.SET_SELECTED_TIME_CLUSTER, value }
}
export const setDepartmentList = (value: ItemList[]) => {
    return { type: FiltersAction.SET_DEPARTMENT_LIST, value }
}
export const setProjectTypeOptions = (value: Record<string, { label: string; value: string }>) => {
    return { type: FiltersAction.SET_PROJECT_TYPE_OPTIONS, value }
}
export const setActivityTypes = (value: any[]) => {
    return { type: FiltersAction.SET_ACTIVITY_TYPES, value }
}
export const setRecipientList = (value: ItemList[]) => {
    return { type: FiltersAction.SET_RECIPIENT_LIST, value }
}
export const setVisibilityList = (value: ItemList[]) => {
    return { type: FiltersAction.SET_VISIBILITY_LIST, value }
}
export const getFiltersError = (error?: any) => {
    return { type: FiltersAction.GET_FILTERS_ERROR, error }
}
export const setStoreIdList = (value: any[]) => {
    return { type: FiltersAction.SET_STORE_ID_LIST, value }
}
export const getDistributionListsSuccess = (value: any) => {
    return { type: FiltersAction.GET_DISTRIBUTION_LISTS_SUCCESS, value }
}
export const getDistributionListsError = (value: any) => {
    return { type: FiltersAction.GET_DISTRIBUTION_LISTS_ERROR, value }
}
export const getDistributionListsRequest = () => {
    return { type: FiltersAction.GET_DISTRIBUTION_LISTS_REQUEST }
}
export const saveDistributionListSuccess = (value: any) => {
    return {
        type: FiltersAction.SAVE_DISTRIBUTION_LIST_SUCCESS,
        value,
        toastList: [
            {
                title: 'Success',
                text: value?.data?.message || 'Store list saved succesfully!',
            },
        ],
    }
}
export const saveDistributionListError = (value: any) => {
    return { type: FiltersAction.SAVE_DISTRIBUTION_LIST_ERROR, value }
}
export const saveDistributionListRequest = () => {
    return { type: FiltersAction.SAVE_DISTRIBUTION_LIST_REQUEST }
}
export const getDistributionLists = () => {
    return (dispatch: any) => {
        dispatch(getDistributionListsRequest())
        FiltersService.GetDistributionLists()
            .then((response: any) => {
                if (response?.data) {
                    dispatch(getDistributionListsSuccess(response?.data))
                } else {
                    dispatch(getDistributionListsError({}))
                }
            })
            .catch((error: any) => {
                dispatch(getDistributionListsError(error))
            })
    }
}
export const saveDistributionList = (name: string, storesId: any[]) => {
    return (dispatch: any) => {
        dispatch(saveDistributionListRequest())
        FiltersService.SaveDistributionList(name, storesId)
            .then((response: any) => {
                dispatch(saveDistributionListSuccess(response))
                dispatch(getDistributionLists())
            })
            .catch((error: any) => {
                dispatch(saveDistributionListError(error))
            })
    }
}
export const setStoreOptionsFilterList = (value: any) => {
    return { type: FiltersAction.SET_STORES_OPTIONS__LIST, value }
}
export const setStoreList = (value: any[], storesCount: number) => {
    return { type: FiltersAction.SET_STORES_LIST, value, storesCount }
}
export const setTypeFilterList = (typeFilter: LayoutActivityType, value: any[]) => {
    return {
        type: FiltersAction.SET_TYPE_FILTERS_LIST,
        value: {
            typeFilter,
            options: value,
        },
    }
}
export const getReportTimesSuccess = (value: any) => {
    return { type: FiltersAction.GET_REPORT_TIMES_SUCCCESS, value }
}
export const getReportTimesError = (value: any) => {
    return { type: FiltersAction.GET_REPORT_TIMES_FAILURE, value }
}
export const getReportTimesRequest = () => {
    return { type: FiltersAction.GET_REPORT_TIMES_REQUEST }
}

const setStatusListOptions = (value: any[]) => {
    return {
        type: FiltersAction.SET_STATUS_LIST_OPTIONS,
        value,
    }
}

const setPrioritiesListOptions = (value: any[]) => {
    return {
        type: FiltersAction.SET_PRIORITIES_LIST_OPTIONS,
        value,
    }
}

export const getAllSubtypes = () => {
    return (dispatch: any) => {
        FiltersService.GetSubTypes(LayoutActivityType.NEWS)
            .then((res: any) => {
                dispatch(
                    setTypeFilterList(
                        LayoutActivityType.NEWS,
                        res.data.list.map((item) => ({
                            value: item,
                            label: item,
                        }))
                    )
                )
            })
            .catch((error: Error) => {
                dispatch(getFiltersError(error))
            })
    }
}

export const setMacroareaList = (value: string[]) => ({
    type: FiltersAction.SET_MACROAREA_LIST,
    value,
})

export const getMacroareas = (banner?: string[]) => {
    return (dispatch: any) => {
        FiltersService.GetMacroareas(banner)
            .then((res: any) => {
                let macroareas = res.data
                dispatch(setMacroareaList(macroareas))
            })
            .catch((error: Error) => {
                dispatch(getFiltersError(error))
            })
    }
}

const setPhotoStatusList = (value: any) => {
    return {
        type: FiltersAction.SET_PHOTO_STATUS_LIST,
        value,
    }
}

export const getPhotoStatusList = () => {
    return (dispatch: any) => {
        FiltersService.GetPictureStatusList()
            .then((res) => {
                let pictureStatusList = res.data?.pictureStatus
                dispatch(setPhotoStatusList({ pictureStatusList }))
            })
            .catch((error: Error) => {
                dispatch(getFiltersError(error))
            })
    }
}

const setPhotoTagList = (value: any) => {
    return {
        type: FiltersAction.SET_PHOTO_TAG_LIST,
        value,
    }
}

export const getPhotoTagList = (banner?: string[]) => {
    return (dispatch: any, getState) => {
        FiltersService.GetPhotoTagList(banner || [getState().userReducer.user.brands[0]])
            .then((res) => {
                let tags = res.data
                dispatch(setPhotoTagList({ tags }))
            })
            .catch((error: Error) => {
                dispatch(getFiltersError(error))
            })
    }
}

// GET RECIPIENTS

export const getRecipients = () => {
    return (dispatch: any) => {
        FiltersService.GetRecipients()
            .then((res: any) => {
                if (res && res.data && res.data.list) {
                    dispatch(
                        setRecipientList(
                            res.data.list.map((item) => ({
                                value: item,
                                label: `modals.filters.recipient.${item}`,
                            }))
                        )
                    )
                } else {
                    dispatch(getFiltersError())
                }
            })
            .catch((error: Error) => {
                dispatch(getFiltersError(error))
            })
    }
}

// GET DEPARTMENTS

export const getDepartments = () => {
    return (dispatch: any) => {
        FiltersService.GetDepartments()
            .then((res: any) => {
                if (res && res.data && res.data.list) {
                    dispatch(
                        setDepartmentList(
                            res.data.list.map((item) => ({
                                value: item,
                                label: `modals.filters.department.${item}`,
                            }))
                        )
                    )
                } else {
                    dispatch(getFiltersError())
                }
            })
            .catch((error: Error) => {
                dispatch(getFiltersError(error))
            })
    }
}

// GET VISIBILITIES

export const getVisibilities = () => {
    return (dispatch: any) => {
        FiltersService.GetVisibilities()
            .then((res: any) => {
                if (res && res.data && res.data.list) {
                    dispatch(
                        setVisibilityList(
                            res.data.list.map((item) => ({
                                value: item,
                                label: `modals.filters.visibility.${item}`,
                            }))
                        )
                    )
                } else {
                    dispatch(getFiltersError())
                }
            })
            .catch((error: Error) => {
                dispatch(getFiltersError(error))
            })
    }
}

const createStoreOptionList = (option) => ({
    value: option,
    label: option,
})

const createBannerStoreOptionList = (option) => ({
    value: option.code,
    label: option.label,
})

export const getStoresList = (showConeOfVision?: boolean) => {
    return (dispatch: any) => {
        FiltersService.GetStoreList({ mode: 'simple', coneOfVision: true, groupedFields: 'all' })
            .then((res: any) => {
                if (res && res.data) {
                    let filterOptions = {
                        macroRegion: res.data?.macroregion ?? [],
                        region: res.data?.region ?? [],
                        country: res.data?.country ?? [],
                        zone: res.data?.zoneDesc ?? [],
                        storeLocation: res.data?.storeLocation ?? [],
                        city: res.data?.city ?? [],
                        segment: res.data?.segment ?? [],
                        host: res.data?.host ?? [],
                        storeHost: res.data?.storeHostName ?? [],
                        businessModel: res.data?.businessModel ?? [],
                        banner: res.data?.bannerObject ?? [],
                    }
                    dispatch(
                        setStoreOptionsFilterList({
                            macroRegion: filterOptions.macroRegion.map(createStoreOptionList),
                            region: filterOptions.region.map(createStoreOptionList),
                            country: filterOptions.country.map(createStoreOptionList),
                            zone: filterOptions.zone.map(createStoreOptionList),
                            storeLocation: filterOptions.storeLocation.map(createStoreOptionList),
                            city: filterOptions.city.map(createStoreOptionList),
                            segment: filterOptions.segment.map(createStoreOptionList),
                            host: filterOptions.host.map(createStoreOptionList),
                            storeHost: filterOptions.storeHost.map(createStoreOptionList),
                            businessModel: filterOptions.businessModel.map(createStoreOptionList),
                            banner: filterOptions.banner.map(createBannerStoreOptionList),
                            coneOfVision: showConeOfVision ? res.data?.coneOfVision : undefined,
                        })
                    )

                    dispatch(setStoreList(res?.data?.stores ?? [], res?.data?.storesCount))
                } else {
                    dispatch(getFiltersError())
                }
            })
            .catch((error: Error) => {
                dispatch(getFiltersError(error))
            })
    }
}

export const getFiltersDomain = (callback?: () => void) => {
    return (dispatch: any) => {
        FiltersService.GetStoreList({
            mode: 'simple',
            coneOfVision: true,
            groupedFields: 'all',
        })
            .then((res: any) => {
                if (res && res.data) {
                    const reduce = res.data.coneOfVision.reduce(
                        (acc, current) => ({
                            ...acc,
                            banner: [...acc.banner, current.banner],
                            region: [...acc.region, current.macroregion],
                            country: [...acc.country, current.country],
                        }),
                        { banner: [], region: [], country: [] }
                    )
                    dispatch(
                        setFiltersDomain(
                            new Set(reduce.banner),
                            new Set(reduce.region),
                            new Set(reduce.country)
                        )
                    )
                    dispatch(setStoreIdList(res.data.stores))
                    const filtersOPtionsMap = res.data
                    delete filtersOPtionsMap.banner
                    delete filtersOPtionsMap.coneOfVision
                    delete filtersOPtionsMap.stores
                    delete filtersOPtionsMap.storesCount
                    dispatch(
                        setFiltersOptionsMap({
                            ...filtersOPtionsMap,
                            bannerObject: res.data.bannerObject,
                        })
                    )
                } else {
                    dispatch(getFiltersError())
                }
            })
            .catch((error: Error) => {
                dispatch(getFiltersError(error))
            })
            .finally(() => callback && callback())
    }
}

// SET IS FULLSCREEN

export const setIsFullScreen = (value: boolean) => {
    return { type: FiltersAction.SET_IS_FULLSCREEN, value }
}

//DELETE FILTERS
const deleteFiltersRequest = () => {
    return { type: FiltersAction.DELETE_FILTERS_REQUEST }
}

const deleteFiltersError = (error?: any) => {
    return {
        type: FiltersAction.DELETE_FILTERS_FAILURE,
        error,
        toastList: [{ title: 'Error', text: 'Filter could not be deleted' }],
    }
}

const deleteFiltersSuccess = () => {
    return {
        type: FiltersAction.DELETE_FILTERS_SUCCESS,
        data: {},
        toastList: [{ title: 'Success', text: 'Filter successfully deleted!' }],
    }
}

//SET FILTER AS FAVOURITE
const saveAsFavoriteRequest = () => {
    return { type: FiltersAction.SET_AS_FAVORITE_REQUEST }
}

const saveAsFavoriteError = (error?: any) => {
    return {
        type: FiltersAction.SET_AS_FAVORITE_FAILURE,
        error,
        toastList: [{ title: 'Error', text: 'Filter could not be setted as favorite' }],
    }
}

const saveAsFavoriteSuccess = () => {
    return {
        type: FiltersAction.SET_AS_FAVORITE_SUCCESS,
        data: {},
        toastList: [{ title: 'Success', text: 'Filter successfully setted as favorite!' }],
    }
}

const filterApplyError = (error?: any) => {
    return {
        type: FiltersAction.APPLY_FILTER_FAILURE,
        error,
        toastList: [{ title: 'Error', text: 'Filter could not be applied' }],
    }
}

const filterApplySuccess = () => {
    return {
        type: FiltersAction.APPLY_FILTER_SUCCESS,
        data: {},
        toastList: [{ title: 'Success', text: 'Filter successfully applied!' }],
    }
}

export const showToastSaveFilterSuccess = () => {
    return {
        type: FiltersAction.SHOW_TOAST_SAVE_FILTER_SUCCESS,
        toastList: [
            {
                title: 'Success',
                text: 'Filter successfully saved!',
            },
        ],
    }
}

export const showToastSaveFilterFailure = () => {
    return {
        type: FiltersAction.SHOW_TOAST_SAVE_FILTER_FAILURE,
        toastList: [
            {
                title: 'Errore',
                text: 'Filter could not be saved',
            },
        ],
    }
}

export const showToastEmptyFilterWarning = (isApplyMessage = false) => {
    return {
        type: FiltersAction.SHOW_TOAST_EMPTY_FILTER_FAILURE,
        toastList: [
            {
                title: 'Error',
                text: isApplyMessage
                    ? 'Cannot apply an empty filter, unless it is the Original Filter'
                    : 'Cannot save an empty filter',
            },
        ],
    }
}

const storeListDownloadSuccess = () => {
    return {
        type: FiltersAction.STORE_LIST_DOWNLOAD_SUCCESS,
        data: {},
        toastList: [
            {
                title: 'Success',
                text: 'Request processed successfully. The file will be sent to your email',
            },
        ],
    }
}
const storeListDownloadError = () => {
    return {
        type: FiltersAction.STORE_LIST_DOWNLOAD_FAILURE,
        data: {},
        toastList: [{ title: 'Error', text: 'Request could not be processed.' }],
    }
}

// const getFiltersSuccess = (value: any[]) => {
//     return { type: FiltersAction.GET_FILTERS_SUCCESS, value }
// }

// export const getFilters = () => (dispatch: any) => {
//     FiltersService.GetFilterList().then((response) => {
//         dispatch(getFiltersSuccess(response?.data?.filters ?? []))
//     })
// }

export const deleteFilters = (filterId: string) => (dispatch: any) => {
    dispatch(deleteFiltersRequest())

    FiltersService.DeleteFilter(filterId)
        .then(async () => {
            await dispatch(filtersActions.loadFilterList())
            filtersActions.loadFilterList()
            dispatch(deleteFiltersSuccess())
        })
        .catch((error) => {
            dispatch(deleteFiltersError())
        })
}

export const setFilterAsFavorite = (filterId: string) => (dispatch: any) => {
    dispatch(saveAsFavoriteRequest())

    FiltersService.SetFavouriteFilter(filterId)
        .then(async (responseFavorite) => {
            if (!responseFavorite?.data?.isBoom) {
                await dispatch(filtersActions.loadFilterList())
                dispatch(saveAsFavoriteSuccess())
                filtersActions.loadFilterList()
            } else {
                dispatch(saveAsFavoriteError())
            }
        })
        .catch((error) => {
            dispatch(saveAsFavoriteError())
        })
}

export const getActivityFiltersOptions = () => (dispatch: any) => {
    FiltersService.GetActivityFiltersOptions()
        .then((response) => {
            if (response?.data?.status?.length > 0) {
                dispatch(
                    setStatusListOptions(
                        response.data.status.map((item) => ({
                            value: item,
                            label: `modals.filters.status.${item}`,
                        }))
                    )
                )

                dispatch(
                    setPrioritiesListOptions(
                        response.data.priorities.map((item) => ({
                            value: item,
                            label: `modals.filters.priorities.${item}`,
                        }))
                    )
                )
            }
        })
        .catch((error) => {
            dispatch(saveAsFavoriteError())
        })
}

/**
 * 1. The filter's type is checked:
 * > if it is Original Filter and already exists, the UpdateFilter service is triggered
 * > if it is Original Filter but does not yet exist, the CreateFilter service is triggered
 * > otherwise the UpdateFilter service is triggered
 *
 * 2. The DoApplyFilter service is triggered
 *
 * 3. The get filterlist is triggered to update the saved filters' list
 */
export const doApplyFilter = (filter: Filter, existAlready: boolean) => async (dispatch: any) => {
    try {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        let filterId = filter._id
        if (filter.isOriginalFilter) {
            if (existAlready) {
                const updateFilterResponse = await FiltersService.UpdateFilter({
                    ...filter,
                    name: filter.name,
                    isOriginalFilter: true,
                })

                if (updateFilterResponse?.data?.isBoom) {
                    //the function is interrupted and the catch (error) is triggered
                    throw updateFilterResponse
                }
            } else {
                const createFilterResponse = await FiltersService.CreateFilter({
                    ...filter,
                    name: 'Original Filter',
                    isOriginalFilter: true,
                })

                if (createFilterResponse?.data?.isBoom) {
                    //the function is interrupted and the catch (error) is triggered
                    throw createFilterResponse
                }
                //to apply a filter you need to have its id so we take it from CreateFilter's response
                filterId = createFilterResponse?.data?.filterId
            }
        } else {
            const updateFilterResponse = await FiltersService.UpdateFilter(filter)

            if (updateFilterResponse?.data?.isBoom) {
                //the function is interrupted and the catch (error) is triggered
                throw updateFilterResponse
            }
        }
        const applyFilterResponse = await FiltersService.DoApplyFilter(filterId)

        if (applyFilterResponse?.data?.isBoom) {
            //the function is interrupted and the catch (error) is triggered
            throw applyFilterResponse
        }

        await dispatch(filtersActions.loadFilterList())
        dispatch(layoutActions.setModals({ props: { loading: false, reloadParentData: true } }))

        //the successful toast message is shown
        dispatch(filterApplySuccess())
    } catch (error) {
        //the error toast message is shown
        dispatch(filterApplyError())
        dispatch(layoutActions.setModals({ props: { loading: false } }))
    }
}
// GET ACTIVITY TYPES

export const getActivityTypes = (callback?: () => void) => (dispatch: any) => {
    dispatch(layoutActions.setModals({ props: { loading: true } }))
    FiltersService.GetActivityTypes()
        .then((response) => {
            if (!!response?.data) {
                dispatch(
                    setProjectTypeOptions(
                        response.data.filterProjectTypes.reduce((acc, curr) => {
                            let res = {
                                ...acc,
                            }
                            res[curr.projectTypeName] = curr.subTypes.map((subType) => ({
                                value: subType.moduleName,
                                label:
                                    subType.moduleName.charAt(0).toUpperCase() +
                                    subType.moduleName.slice(1),
                            }))
                            return res
                        }, {})
                    )
                )
                !!callback && callback()
            }
        })
        .catch(() => {
            dispatch(layoutActions.setModals({ props: { loading: false } }))
        })
}

export const getFiltersActivityTypes = (callback?: () => void) => (dispatch: any) => {
    dispatch(layoutActions.setModals({ props: { loading: true } }))
    FiltersService.GetActivityTypes({ feCheck: false })
        .then((response) => {
            if (!!response?.data) {
                dispatch(
                    setActivityTypes(response.data.filterProjectTypes.map((t) => t.projectTypeName))
                )
                dispatch(
                    setProjectTypeOptions(
                        response.data.filterProjectTypes.reduce((acc, curr) => {
                            let res = {
                                ...acc,
                            }
                            res.activity = [
                                ...(res.activity || []),
                                ...curr.subTypes.map((subType) => ({
                                    value: `${curr.projectTypeName}_${subType.projectSubTypeName}`,
                                    label: `modals.filters.options_container.group.${curr.projectTypeName}_${subType.projectSubTypeName}`,
                                })),
                            ]

                            return res
                        }, {})
                    )
                )
                !!callback && callback()
            }
        })
        .catch(() => {
            dispatch(layoutActions.setModals({ props: { loading: false } }))
        })
}

// GET REPORT TIMES

export const getReportTimes = () => {
    return (dispatch: any) => {
        dispatch(getReportTimesRequest())
        FiltersService.GetReportTiming()
            .then((res: any) => {
                if (res?.data && res?.data?.reportTimes) {
                    dispatch(getReportTimesSuccess(res.data.reportTimes))
                } else {
                    dispatch(getReportTimesError({}))
                }
            })
            .catch((error: any) => {
                dispatch(getReportTimesError(error))
            })
    }
}

export const downloadStoreList = (mode: 'simple' | 'standard', storeIdList: string[]) => {
    return (dispatch: any) => {
        FiltersService.DownloadStoreList(
            mode,
            true,
            undefined,
            undefined,
            undefined,
            undefined,
            storeIdList,
            'all'
        )
            .then(() => {
                dispatch(storeListDownloadSuccess())
            })
            .catch(() => {
                dispatch(storeListDownloadError())
            })
    }
}

export const getMacroareaList = (banner: string, callback: (res: any) => void) => {
    return () => {
        FiltersService.GetMacroareaList(banner).then((res: any) => {
            if (res?.data) {
                callback({ macroareaList: res.data })
            }
        })
    }
}
export const getStoreDetails = (storeId: string, callback: (res: any) => void) => {
    return (dispatch: any) => {
        FiltersService.GetStoreList({
            mode: 'standard',
            coneOfVision: true,
            tableFilters: { storeId },
        }).then((res: any) => {
            if (res?.data && res?.data?.stores) {
                callback({ storeDetail: res.data.stores[0] })
                dispatch(getMacroareaList(res.data.stores[0].banner, callback))
            }
        })
    }
}
